<template>
  <div class="self-order-header">
    <div class="left">
      <span class="status">
        <span style="vertical-align: middle">{{ title }}</span>
      </span>
    </div>
    <div class="right">
      <el-button @click="goBack">返回</el-button>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'detail-page-header',
  props: {
    beforeGoBack: {
      type: Function
    },
    title: {
      type: String
    }
  },
  methods: {
    async goBack() {
      if (this.beforeGoBack && typeof this.beforeGoBack === 'function') {
        let noBack = await this.beforeGoBack()
        if (!noBack) this.$router.go(-1)
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.self-order-header {
  height: 80px;
  line-height: 80px;
  background: #fff;
  // border:1px solid rgba(216,216,216,1);
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 30px;
  user-select: none;
  z-index: 100;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // box-shadow: 1px -1px 10px 1px rgb(234, 234, 234);
  .left {
    float: left;
    height: 78px;
    .status {
      font-size: 16px;
      font-weight: 400;
      color: #606060;
      margin-right: 56px;
      .text {
        font-size: 18px;
      }
    }
    .less {
      font-size: 16px;
      color: #606060;
      .time {
        font-size: 18px;
      }
      .time,
      .prompt {
        color: #f15050;
      }
      .prompt {
        margin-left: 6px;
        font-size: 12px;
      }
    }
  }
  .right {
    float: right;
    // height: 78px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail-page/header.vue